// Greenland - JavaScript Global
// Funcionalidades generales de la aplicación

document.addEventListener('DOMContentLoaded', function() {
    // Asegurar que el spinner esté oculto al cargar
    ocultarSpinner();
    
    // Inicializar funcionalidades generales
    inicializarMenuDeslizante();
    inicializarModales();
    inicializarNotificaciones();
});

// Funcionalidad del menú deslizante
function inicializarMenuDeslizante() {
    const menuIcon = document.querySelector('.menu-icon');
    const menuOverlay = document.querySelector('.menu-overlay');
    const menuCerrar = document.querySelector('.menu-cerrar');
    const menuDeslizante = document.querySelector('.menu-deslizante');

    if (menuIcon && menuOverlay) {
        // Abrir menú
        menuIcon.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            abrirMenu();
        });

        // Cerrar menú con el botón X
        if (menuCerrar) {
            menuCerrar.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                cerrarMenu();
            });
        }

        // Cerrar menú al hacer clic fuera
        menuOverlay.addEventListener('click', function(e) {
            if (e.target === menuOverlay) {
                cerrarMenu();
            }
        });

        // Cerrar menú con Escape
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && menuOverlay.classList.contains('activo')) {
                cerrarMenu();
            }
        });

        // Prevenir que los clics dentro del menú lo cierren
        if (menuDeslizante) {
            menuDeslizante.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        }
    }
}

function abrirMenu() {
    const menuOverlay = document.querySelector('.menu-overlay');
    const menuDeslizante = document.querySelector('.menu-deslizante');
    
    if (menuOverlay && menuDeslizante) {
        // Mostrar overlay
        menuOverlay.classList.remove('oculto');
        menuOverlay.classList.add('activo');
        
        // Animar el menú deslizante
        setTimeout(() => {
            menuDeslizante.classList.add('activo');
        }, 10);
        
        // Bloquear scroll del body
        document.body.style.overflow = 'hidden';
    }
}

function cerrarMenu() {
    const menuOverlay = document.querySelector('.menu-overlay');
    const menuDeslizante = document.querySelector('.menu-deslizante');
    
    if (menuOverlay && menuDeslizante) {
        // Animar el cierre del menú
        menuDeslizante.classList.remove('activo');
        
        // Ocultar overlay después de la animación
        setTimeout(() => {
            menuOverlay.classList.remove('activo');
            menuOverlay.classList.add('oculto');
            
            // Restaurar scroll del body
            document.body.style.overflow = '';
        }, 300); // Tiempo de la animación CSS
    }
}

// Funcionalidad de modales
function inicializarModales() {
    // Cerrar modales con Escape
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            const modales = document.querySelectorAll('.modal');
            modales.forEach(modal => {
                if (modal.style.display === 'block') {
                    modal.style.display = 'none';
                }
            });
        }
    });
}

// Sistema de notificaciones
function inicializarNotificaciones() {
    // Crear contenedor de notificaciones si no existe
    if (!document.getElementById('notificacion-container')) {
        const notificaciones = document.createElement('div');
        notificaciones.id = 'notificacion-container';
        notificaciones.className = 'notificacion-container';
        document.body.appendChild(notificaciones);
    }
}

// Función para mostrar notificaciones
function mostrarNotificacion(mensaje, tipo = 'info') {
    const notificaciones = document.getElementById('notificacion-container');
    const notificacion = document.createElement('div');
    notificacion.classList.add('notificacion');
    
    if (tipo === 'error') {
        notificacion.innerHTML = '<i>❌</i> ' + mensaje;
    } else if (tipo === 'alerta') {
        notificacion.innerHTML = '<i>⚠️</i> ' + mensaje;
    } else {
        notificacion.innerHTML = '<i>✅</i> ' + mensaje;
    }
    
    notificaciones.appendChild(notificacion);
    
    // Animar entrada
    setTimeout(() => {
        notificacion.style.opacity = '1';
        notificacion.style.transform = 'translateY(0)';
    }, 100);
    
    // Auto-remover después de 4 segundos
    setTimeout(() => {
        notificacion.style.opacity = '0';
        notificacion.style.transform = 'translateY(-20px)';
        setTimeout(() => {
            if (notificacion.parentNode) {
                notificacion.parentNode.removeChild(notificacion);
            }
        }, 300);
    }, 4000);
}

// Funciones del spinner
function mostrarSpinner() {
    const spinner = document.getElementById('spinner-carga');
    if (spinner) {
        spinner.classList.remove('oculto');
    }
}

function ocultarSpinner() {
    const spinner = document.getElementById('spinner-carga');
    if (spinner) {
        spinner.classList.add('oculto');
    }
}

// Funciones de utilidad para formularios
function validarFormulario(formulario) {
    const campos = formulario.querySelectorAll('[required]');
    let valido = true;

    campos.forEach(campo => {
        if (!campo.value.trim()) {
            campo.classList.add('error');
            valido = false;
        } else {
            campo.classList.remove('error');
        }
    });

    return valido;
}

function limpiarFormulario(formulario) {
    formulario.reset();
    formulario.querySelectorAll('.error').forEach(campo => {
        campo.classList.remove('error');
    });
}

// Funciones para manejo de datos
function formatearFecha(fecha) {
    if (!fecha) return 'N/A';
    return new Date(fecha).toLocaleDateString('es-ES');
}

function formatearTelefono(telefono) {
    if (!telefono) return 'N/A';
    return telefono.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
}

// Funciones para API
async function hacerPeticion(url, opciones = {}) {
    try {
        const respuesta = await fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                ...opciones.headers
            },
            ...opciones
        });

        const datos = await respuesta.json();
        
        if (!respuesta.ok) {
            throw new Error(datos.message || 'Error en la petición');
        }

        return datos;
    } catch (error) {
        console.error('Error en petición:', error);
        mostrarNotificacion(error.message, 'error');
        throw error;
    }
}



// Funciones para modales

const modal = document.querySelector('.modal');
const modalContent = document.querySelector('.modal-content');
const overlay = document.querySelector('.overlay');

function abrirModal(template) {
    // Limpiar contenido previo del modal
    if (modalContent) {
        modalContent.innerHTML = '';
    }
  
    if (modal) {
        modal.style.display = 'block';
        // Si se proporciona un template, cargarlo
        if (template) {
            const divCerrar = document.createElement('div');

            const cerrar = document.createElement('button');
            cerrar.className = 'btn cerrar';
            cerrar.innerHTML = '&times;';
            cerrar.addEventListener('click', cerrarModal);
            modalContent.appendChild(cerrar);

            modalContent.appendChild(template.content.cloneNode(true));

        }
        overlay.style.display = 'block';
        // Enfocar el primer campo del formulario
        const primerCampo = modal.querySelector('input, select, textarea');
        if (primerCampo) {
            console.log(primerCampo)
            primerCampo.focus();
        }
    }
}

function cerrarModal() {

    if (modal) {
        modal.style.display = 'none';
        overlay.style.display = 'none';
        // Limpiar formulario si existe
        const formulario = modal.querySelector('form');
        if (formulario) {
            limpiarFormulario(formulario);
        }
    }
}

// Funciones para confirmaciones
function confirmarAccion(mensaje, callback) {
    if (confirm(mensaje)) {
        callback();
    }
}

// Funciones para estados de carga
function mostrarCarga(elemento) {
    if (elemento) {
        elemento.classList.add('cargando');
        elemento.disabled = true;
    }
}

function ocultarCarga(elemento) {
    if (elemento) {
        elemento.classList.remove('cargando');
        elemento.disabled = false;
    }
}

// Exportar funciones para uso global
export  {
    mostrarNotificacion,
    mostrarSpinner,
    ocultarSpinner,
    validarFormulario,
    limpiarFormulario,
    formatearFecha,
    formatearTelefono,
    hacerPeticion,
    abrirModal,
    cerrarModal,
    confirmarAccion,
    mostrarCarga,
    ocultarCarga,
    abrirMenu,
    cerrarMenu
};


